import { useCallback } from 'react'
import { BackHandler } from 'react-native'
import { useFocusEffect, useRouter } from 'expo-router'

import { useStore } from '../../models'

const useFirstGameHardwareBackButtonHandler = () => {
  const router = useRouter()

  const {
    game: { setIsMyFirstGame, resetFirstGame }
  } = useStore()

  useFocusEffect(
    useCallback(() => {
      const backAction = () => {
        setIsMyFirstGame(false)
        resetFirstGame()
        router.replace('/(root)/(tabs)')
        return true
      }
      const backHandler = BackHandler.addEventListener('hardwareBackPress', backAction)
      return () => backHandler.remove()
    }, [resetFirstGame, setIsMyFirstGame])
  )
}

export default useFirstGameHardwareBackButtonHandler
